import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { register as registerSW } from './serviceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker — enables PWA install on Android + iOS
// iOS: user taps Share → Add to Home Screen in Safari
// Android: Chrome shows install prompt automatically
registerSW();
